import React from 'react';

import {
  ButtonProps,
  ButtonVariant,
  ButtonSize,
  buttonVariant,
  buttonSize
} from './types';
import { OmegaButton } from './OmegaButtonComponent';
import { ShadcnButton } from './ShadcnButtonComponent';

const ButtonComponent: React.FC<ButtonProps> = React.memo(
  (props: ButtonProps) => {
    const { designSystemType, ...otherProps } = props;

    // Determine which component to render based on designSystemType
    const shouldUseShadcnDesignSystem =
      designSystemType && designSystemType === 'SHADCN_DESIGN_SYSTEM';

    const Component = shouldUseShadcnDesignSystem
      ? ShadcnButton
      : OmegaButton;

    return <Component {...otherProps} />;
  }
);

ButtonComponent.displayName = 'ButtonComponent';

export { ButtonComponent };
export type { ButtonVariant, ButtonSize };
export { buttonVariant, buttonSize };
